import IntakeConfig from '../../interfaces/IntakeConfig.interface';
import getAddonList from '../../services/getAddonList';
import { FormState } from './state';

const normalizeFormState = (state: FormState, config: IntakeConfig) => {
  return {
    ...state,
    ...normalizePlans(state, config),
    ...normalizePlan(state, config),
  };
};

// This is the newer version for handling a single plan with multiple versions and addons
const normalizePlan = (state: FormState, config: IntakeConfig) => {
  if (!config.plan) return {};
  const planCountry = config.plan.countries[state.address.country];
  if (!planCountry) return {};
  const planPeriod = planCountry.periods.find(p => p.id === state.plan);
  if (!planPeriod) return {};
  return {
    plan: planPeriod.id,
    addons: getAddonList(config, state),
  };
};

const normalizePlans = (state: FormState, config: IntakeConfig) => {
  if (!config.plans) return {};
  const planConfig = config.plans.find(p => p.value === state.plan);

  const plan = planConfig?.values
    ? planConfig.values[state.address.country]
    : state.plan;
  return { plan };
};

export default normalizeFormState;
